import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreAuthModule } from './auth/keycloak/auth.provider.module';

@NgModule({
  imports: [CommonModule, CoreAuthModule],
  exports: [CoreAuthModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule ya fue cargado. Importar solo en AppModule.');
    }
  }
}
